var max = Math.max;
var min = Math.min;
var round = Math.round;

export { min as a, max as m, round as r };
//# sourceMappingURL=math-DYbrqK2d.js.map
